exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-area {\n  width: 307px;\n}\n.preview-area p {\n  font-size: 1.25rem;\n  margin: 0;\n  margin-bottom: 1rem;\n}\n.preview-area p:last-of-type {\n  margin-top: 1rem;\n}\n.preview {\n  width: 100%;\n  height: calc(744px * (9 / 16));\n  overflow: hidden;\n  border: solid 1px;\n}\nli {\n  cursor: pointer;\n  padding: 10px;\n  border: solid #ddd 1px;\n}\n.v-menu__content {\n  overflow-y: hidden;\n}\n", ""]);

// exports
